import { render, staticRenderFns } from "./dormitoryList.vue?vue&type=template&id=13957eb1"
import script from "./dormitoryList.vue?vue&type=script&lang=js"
export * from "./dormitoryList.vue?vue&type=script&lang=js"
import style0 from "./dormitoryList.vue?vue&type=style&index=0&id=13957eb1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports